import fetch from "auth/FetchInterceptor";

const setorService = {};

setorService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/sector",
		method: "get",
		params,
	});

	// return (
	// 	[
	// 		...Array(30).keys()
	// 	].map((i) => ({
	// 		id: i,
	// 		nome: `Setor ${i}`,
	// 	}))
	// );
};

setorService.post = function (data) {
	return fetch({
		url: "/v1/rest/sector",
		method: "post",
		data: data,
	});
};

setorService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/sector/${id}`,
		method: "put",
		data: data,
	});
};

setorService.getById = function (id) {
	return fetch({
		url: `/v1/rest/sector/${id}`,
		method: "get",
	});
};

export default setorService;
